<sam4-first-page-layout>
    <h1 class="text-danger" style="padding-top:12px;">Session Not Activated</h1>
    <p>Try your viewer link again in a few minutes.</p>
    <a routerLink="/">Return to the homepage</a>
</sam4-first-page-layout>
